const prescription = {
  preOrderMessage: 'Vorbestellung von Arzneimitteln mit',
  scanned: 'Gescannt',
  uploaded: 'Hochgeladen',
  noteToPharmacy: 'Hinweis an Apotheke',
  yourComment: 'Ihr Kommentar ...',
}

export default prescription
